import React, { useState } from 'react';
import MainMenu from '../../components/menu/Menu';
import { Layout, Spin } from 'antd';
import LocationMapAll from '../../components/locationMap/LocationMapAll';
import SideMenuCams from '../../components/sideMenuCams/SideMenuCams';
import { useDevicesLoader } from '../../hooks/useDevicesLoader';
import './style/style.css';
import { LoadingOutlined } from '@ant-design/icons';

const { Header, Sider, Content } = Layout;

const Map: React.FC = () => {
    const [currentMenuItem, setCurrentMenuItem] = useState('map');
    const [selectedDeviceUID, setSelectedDeviceUID] = useState<string | null>(null);
    const { devices, isLoading } = useDevicesLoader();

    const handleMenuClick = (key: string) => {
        setCurrentMenuItem(key);
    };

    return (
        <Layout className="map-layout-root">
            <Header className="map-header">
                <div className="menu">
                    <MainMenu onClick={handleMenuClick} currentMenuItem={currentMenuItem} />
                </div>
            </Header>
            <Layout className="map-layout-inner">
                {isLoading && (
                    <div className="map-loading-overlay">
                        <Spin indicator={<LoadingOutlined className={'spin-icon'} spin />} />
                    </div>
                )}
                <Sider className="map-sider" width={264}>
                    <SideMenuCams
                        devices={devices}
                        onSelect={setSelectedDeviceUID}
                        onReset={() => setSelectedDeviceUID(null)}
                        selectedUID={selectedDeviceUID}
                    />
                </Sider>
                <Content className="map-content">
                    <LocationMapAll
                        devices={devices}
                        selectedDeviceUID={selectedDeviceUID || undefined}
                        onSelectDeviceUID={(uid) => setSelectedDeviceUID(uid ?? null)}
                    />
                </Content>
            </Layout>
        </Layout>
    );
};

export default Map;
